import React from "react";

export default function SMEChallenges() {
    return (
        <div className="px-4 sm:px-14 lg:px-24 py-8 text-black text-[32px] leading-tight">
            <h1 className="text-[#03897B] font-bold mb-6">CHALLENGES</h1>
            <p className="mb-8 font-normal">Top Challenges Faced by SMEs in South Africa</p>

            <div className="space-y-8">
                {[
                    {
                        title: "1. Access to Finance",
                        points: [
                            "One of the biggest hurdles for SMEs.",
                            "Many lack collateral or formal credit history.",
                            "Struggles to qualify for traditional funding from banks.",
                            "Limited access to government grants, venture capital, or microfinance.",
                        ],
                    },
                    {
                        title: "2. Regulatory and Compliance Burdens",
                        points: [
                            "Complex registration processes, tax compliance, and B-BBEE requirements.",
                            "Many SMEs lack the skills or resources to navigate red tape and paperwork.",
                            "Compliance with labour laws, health & safety, and sector regulations can be overwhelming for small teams.",
                        ],
                    },
                    {
                        title: "3. Market Access and Competition",
                        points: [
                            "Difficulty penetrating formal supply chains, especially retail or export markets.",
                            "Limited exposure and branding vs. larger, established players.",
                            "Often overlooked in procurement by corporates and government despite preferential policies.",
                        ],
                    },
                    {
                        title: "4. Skills Gaps",
                        points: [
                            "Many entrepreneurs lack business management and financial literacy skills.",
                            "Challenges hiring and retaining skilled staff due to budget constraints.",
                            "Limited opportunities for continuous learning and mentorship.",
                        ],
                    },
                    {
                        title: "5. Infrastructure and Technology Access",
                        points: [
                            "In rural areas, unreliable electricity, internet, and transport networks can hinder operations.",
                            "Lack of digital tools, systems, and capacity to compete in a tech-driven economy.",
                        ],
                    },
                    {
                        title: "6. Cash Flow and Late Payments",
                        points: [
                            "Poor payment culture, especially from big clients (including government).",
                            "Long payment cycles (60+ days) affect liquidity and day-to-day operations.",
                            "Difficulty managing budgets, stock, and credit.",
                        ],
                    },
                    {
                        title: "7. Limited Mentorship and Support Networks",
                        points: [
                            "Many entrepreneurs operate in isolation, without access to mentorship, peer networks, or incubation hubs.",
                            "Lack of exposure to experienced entrepreneurs and advisors limits growth potential.",
                        ],
                    },
                    {
                        title: "8. Economic and Political Instability",
                        points: [
                            "Load-shedding, inflation, and rising interest rates increase operational costs.",
                            "Policy uncertainty affects investor confidence and long-term planning.",
                        ],
                    },
                    {
                        title: "9. Lack of Innovation and Differentiation",
                        points: [
                            "Many businesses offer similar products/services in saturated markets.",
                            "Limited support for R&D, product development, or IP protection.",
                            "Struggle to scale or pivot in changing markets.",
                        ],
                    },
                    {
                        title: "10. Access to Information and Opportunities",
                        points: [
                            "Many SMEs are unaware of available funding, training, and support programmes.",
                            "Digital divide keeps many disconnected from platforms that could grow their business.",
                        ],
                    },
                    {
                        title: "Others",
                        points: [
                            "Crime & security risks (especially for township businesses)",
                            "Gender & youth-specific barriers",
                            "Underdeveloped rural enterprise ecosystems",
                        ],
                    },
                ].map((item, idx) => (
                    <div key={idx}>
                        <p className="font-semibold mb-2">{item.title}</p>
                        <ul className="list-disc pl-5 space-y-2">
                            {item.points.map((point, i) => (
                                <li key={i}>{point}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <style jsx>{`
                @media (max-width: 640px) {
                    div {
                        font-size: 8px;
                    }
                }
            `}</style>
        </div>
    );
}
